import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import privacy from '../data/PrivacyNotice.pdf';
import * as Accounts from '../store/Accounts';

class PrivacyNoticeInternal extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccept = this.handleAccept.bind(this);
        this.handleDecline = this.handleDecline.bind(this);
    }

    handleAccept() {
        this.props.accountsDispatch.addAcceptPrivacyPolicy();
    }

    handleDecline() {
        this.props.accountsDispatch.signOut();
    }

    render() {
        const accept = "Accept";
        const decline = "Decline";

        return (
            <div>
                <p>HeartcoR Solutions is committed to protecting your data privacy.</p>
                <p>We use cookies on this site to enhance your user experience.</p>
                <p>Please review the HeartcoR <a href={privacy}>privacy notice</a>.</p>
                <p><b>You accept the HeartcoR privacy notice and use of cookies by clicking the "Accept" button below.</b></p>
                <Button className="button" onClick={this.handleAccept} title={accept}>
                    {accept}
                </Button>{" "}
                <Button className="button" onClick={this.handleDecline} title={decline}>
                    {decline}
                </Button>
            </div>
        );
    }
}

const PrivacyNoticeConnect = connect(
    state => ({
        accountsState: state.accounts
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch)
    })
)(PrivacyNoticeInternal);

export default class PrivacyNotice extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <PrivacyNoticeConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyNotice.js